module.exports = __webpack_public_path__ + "static/media/Milan_WelcomeKit_IT_digital_111119.f0ade807.pdf";